import { z } from 'zod';
import { ApiClient } from '../lib/api';
import {
    CreateInvoice,
    CreateInvoiceSchema,
    Invoice,
    InvoiceSchema,
    UpdateInvoice,
    UpdateInvoiceSchema,
} from '../models/invoice';

export class InvoiceService {
    private api: ApiClient;

    constructor(baseURL: string, stage: string) {
        this.api = new ApiClient(`${baseURL}/${stage}/invoice-service-${stage}`, stage);
    }

    private setDefaults(data: Partial<Invoice>): Invoice {
        return {
            ...data,
        } as Invoice;
    }

    async getAllInvoices(): Promise<Invoice[]> {
        const invoices = await this.api.request(
            { method: 'GET', url: '/invoices' },
            InvoiceSchema.array()
        );
        return invoices.map(invoice => this.setDefaults(invoice));
    }

    async getInvoiceById(id: number): Promise<Invoice> {
        const invoice = await this.api.request(
            { method: 'GET', url: `/invoices/${id}` },
            InvoiceSchema
        );
        return this.setDefaults(invoice);
    }

    async createInvoice(data: CreateInvoice): Promise<Invoice> {
        const invoice = await this.api.request(
            {
                method: 'POST',
                url: '/invoices',
                data: CreateInvoiceSchema.parse(data)
            },
            InvoiceSchema
        );
        return this.setDefaults(invoice);
    }

    async updateInvoice(id: number, data: UpdateInvoice): Promise<Invoice> {
        const invoice = await this.api.request(
            {
                method: 'PUT',
                url: `/invoices/${id}`,
                data: UpdateInvoiceSchema.parse(data)
            },
            InvoiceSchema
        );
        return this.setDefaults(invoice);
    }

    async deleteInvoice(id: number): Promise<void> {
        await this.api.request(
            { method: 'DELETE', url: `/invoices/${id}` },
            z.void()
        );
    }
} 